const parseAuthToken = (jwt) => {
    return JSON.parse(atob(jwt.split('.')[1]))
}

export default parseAuthToken
